import React from 'react';
import { ProgressRing } from '../ui/ProgressRing';
import { formatFullDate } from '../../utils/date';
interface HomeHeaderProps {
  completed: number;
  total: number;
}
function getGreeting(): string {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 18) return 'Good afternoon';
  return 'Good evening';
}
export function HomeHeader({
  completed,
  total
}: HomeHeaderProps) {
  const progress = total > 0 ? completed / total * 100 : 0;
  return <div className="flex shrink-0 items-center justify-between border-b border-slate-100 bg-white/80 px-5 pb-5 pt-6 backdrop-blur-sm" data-id="element-67" data-mp="fmw1o28n6faw">
      <div data-id="element-68" data-mp="tfbzmomorn4y">
        <p className="text-sm text-slate-400" data-id="element-69" data-mp="tf28uytthby7">{formatFullDate()}</p>
        <h1 className="mt-0.5 text-xl font-semibold text-slate-900" data-id="element-70" data-mp="olzlj8fmuyqg">{getGreeting()}</h1>
      </div>
      {total > 0 && <ProgressRing progress={progress} size={52} strokeWidth={5} progressColor="#0d9488" data-id="element-71" data-mp="vn6zepvu3qw">
          <span className="text-xs font-semibold text-slate-700" data-id="element-72" data-mp="3t0r214883u4h">
            {completed}/{total}
          </span>
        </ProgressRing>}
    </div>;
}